module.exports = __webpack_public_path__ + "img/filter-movement.73994ab2.png";